var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7V4c0-.275.225-.5.5-.5h7.172c.131 0 .26.053.353.147l.828.828a.5.5 0 0 1 .147.353V7H16V4.828a2 2 0 0 0-.584-1.415l-.832-.828A2 2 0 0 0 13.172 2H6c-1.103 0-2 .897-2 2v3zm.5 6.5h8v3H6zM5.5 12c-.553 0-1 .447-1 1h-1v-3c0-.275.225-.5.5-.5h12c.275 0 .5.225.5.5v3h-1c0-.553-.447-1-1-1zm10 2.5H17c.553 0 1-.447 1-1V10c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v3.5c0 .553.447 1 1 1h1.5V17c0 .553.447 1 1 1h9c.553 0 1-.447 1-1z"
  })));
};
export default SvgPrint;